import { Box, Title } from '@mantine/core';
import { UserForm } from '../components/UserForm';

export const AddUser = () => {
  return (
    <Box>
      <Title order={3} mb={12}>
        Create new user
      </Title>
      <UserForm user={null} />
    </Box>
  );
};
